import { ChangeEvent, FormEvent, useState } from 'react';

export interface UsePhoenixFormResult<T> {
  formData: T;
  setFormData: React.Dispatch<React.SetStateAction<T>>;
  setValue: (values: Partial<T>) => void;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

const usePhoenixForm = <T,>(
  defaultValues?: Partial<T>
): UsePhoenixFormResult<T> => {
  const [formData, setFormData] = useState<T>({
    ...(defaultValues || {})
  } as T);

  const onChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLSelectElement;

    // Check if the target element is a checkbox
    const isChecked =
      type === 'checkbox' ? (e.target as HTMLInputElement).checked : undefined;

    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: isChecked !== undefined ? isChecked : value
    }));
  };

  const setValue = (values: Partial<T>) => {
    setFormData({
      ...formData,
      ...values
    });
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log({ formData });
  };
  return { formData, setFormData, setValue, onChange, onSubmit };
};

export default usePhoenixForm;
